/*
 * 3-А5 «Согласия» — числа из макета «Каталог и клиенты - П2»: колонка 640, зазор 14,
 * основание (ПД) — сплошная рамка 1.5 цветом бренда, реклама — пунктир и тёплый фон,
 * прочие согласия — сеткой в две колонки (зазор 8), подписи 11.5–12.
 */

.panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 640px;
  padding: 16px 18px 18px;
  font-size: 12.5px;
  line-height: 1.5;
}

.title {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
}

.muted {
  font-size: 12px;
  color: var(--text-secondary);
}

.alert {
  padding: 10px 12px;
  font-weight: var(--font-weight-semibold);
  color: var(--danger-hover);
  background: var(--status-no-show-bg);
  border-radius: 8px;
}

.notice {
  padding: 10px 12px;
  color: var(--text-brand);
  background: var(--bg-sunken);
  border-radius: 8px;
}

.basis,
.ads {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border-radius: 10px;
}

.basis {
  background: var(--bg-card);
  border: 1.5px solid var(--text-brand);
}

.ads {
  background: var(--consent-ads-bg);
  border: 1px dashed var(--consent-ads-border);
}

.kicker {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-brand);
}

.ads .kicker {
  color: var(--consent-ads-border);
}

.row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.grow {
  flex: 1;
  min-width: 0;
}

.name {
  font-size: 13.5px;
  font-weight: var(--font-weight-semibold);
}

.stateCol {
  flex: none;
  max-width: 45%;
  text-align: right;
}

.state {
  font-weight: var(--font-weight-semibold);
}

.given {
  color: var(--status-in-progress-fg);
}

.revoked {
  color: var(--danger-hover);
}

.never {
  color: var(--text-secondary);
}

.sub {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  font-size: 12px;
}

.paper {
  margin-left: auto;
  color: var(--text-secondary);
}

.textLink {
  padding: 0;
  font: inherit;
  color: var(--text-brand);
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: 0;
}

.textLink:disabled {
  color: var(--text-secondary);
  text-decoration-style: dotted;
  cursor: help;
}

.others {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.other {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.otherHead {
  display: flex;
  gap: 8px;
  justify-content: space-between;
}

.otherHead .state {
  white-space: nowrap;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 11.5px;
  color: var(--text-secondary);
}

.legend b {
  font-weight: var(--font-weight-semibold);
}

.history {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0 0;
  margin: 0;
  font-size: 11.5px;
  color: var(--text-secondary);
  list-style: none;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.dialogBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: min(440px, 100%);
}

.dialogButtons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

@media (max-width: 767px) {
  .panel {
    padding: 14px;
  }

  .row {
    flex-direction: column;
    gap: 4px;
  }

  .stateCol {
    max-width: none;
    text-align: left;
  }

  .others {
    grid-template-columns: 1fr;
  }

  .paper {
    margin-left: 0;
  }
}
